import React from 'react';
import { Colors } from '../../theme';

export default function Highlight({
    color = Colors.lightTurq,
    children,
}: {
    color?: string;
    children?: React.ReactNode;
}) {
    return (
        <span style={{ position: 'relative', display: 'inline-block' }}>
            <span
                style={{
                    position: 'relative',
                    zIndex: 1,
                }}
            >
                {children}
            </span>
            <span
                style={{
                    content: '""',
                    position: 'absolute',
                    bottom: '0.05em',
                    left: 0,
                    right: 0,
                    height: '0.4em',
                    backgroundColor: color,
                    transform: 'skewX(-12deg)',
                    zIndex: 0,
                }}
            />
        </span>
    );
}
